// Returns the filter options with the selected filter options indicated.
export const getFilterSections = (filter, selectedValues) => {
    // Updating the filter option 'selected' property to be true if it matches one of the selected values which are defined by the selectedValues param.
    return Object.entries(filter.sections).reduce((acc, filterSection) => {
        const [key, section] = filterSection;
        acc[key] = {
            fixed: section.fixed,
            options: section.options.map(option => {
                var _a;
                return (Object.assign(Object.assign({}, option), { selected: !!((_a = selectedValues[key]) === null || _a === void 0 ? void 0 : _a.includes(option.value)) }));
            })
        };
        return acc;
    }, {});
};
